import React from 'react';

const Footer = () => {
    return (
        <div className='bg-light fixed-bottom py-3 text-center'>
            <p><small>All Right reserved By Coder E-Learnig Platform</small></p>
        </div>
    );
};

export default Footer;